import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
  },

  prefix: {
    color: theme.palette.text.primary,
    lineHeight: 1,

    [theme.breakpoints.down('lg')]: {
      paddingRight: theme.spacing(0.5),
    },
  },

  time: {
    fontSize: theme.spacing(3.25),
    lineHeight: 1,
  },
}));
